import { PropsWithChildren } from 'react';
import { FlexBoxProps } from '@ardoq/layout';
import { AssetTypeIcon, AssetTypeWithIcon } from '@ardoq/icons';
import { DecoratorWrapper } from './atoms';

type AssetTypeIconDecoratorProps = Omit<
  FlexBoxProps,
  'gap' | 'flexDirection'
> & {
  assetType?: AssetTypeWithIcon;
  iconTooltipText?: string;
  maxWidth?: string;
};

export const AssetTypeIconDecorator = ({
  children,
  assetType,
  iconTooltipText,
  ...spaceProps
}: PropsWithChildren<AssetTypeIconDecoratorProps>) => (
  <DecoratorWrapper $skipIconColor {...spaceProps}>
    {assetType && (
      <AssetTypeIcon assetType={assetType} tooltipText={iconTooltipText} />
    )}
    {children}
  </DecoratorWrapper>
);
